module.exports = __webpack_public_path__ + "img/explosion.7da95a8e.svg";